import { render, staticRenderFns } from "./NewsExportPopup.vue?vue&type=template&id=fdab4890"
import script from "./NewsExportPopup.js?vue&type=script&lang=js&external"
export * from "./NewsExportPopup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports